import React from 'react';
import cn from 'classnames';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const KeyValuePair: React.FC<{
  title: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, children }) => {
  return (
    <Spacing direction="vertical" size="xs" className="items-start">
      <span className="text-gray-600 text-xs">{title}</span>
      <div>{children}</div>
    </Spacing>
  );
};

export type ValueVariant = 'base' | 'md' | 'lg';
export type TextSizeClassName = string;

const variantClassNames: Record<ValueVariant, TextSizeClassName> = {
  base: 'text-xl font-bold',
  md: 'text-2xl font-bold',
  lg: 'text-4xl font-bold',
};

export const Value: React.FC<{
  children: React.ReactNode;
  variant?: ValueVariant;
}> = ({ children, variant = 'base' }) => {
  return (
    <span
      className={cn('text-gray-900 leading-none', variantClassNames[variant])}
    >
      {children}
    </span>
  );
};
